import { createApp } from 'vue';
import { AbortablePromise, AbortError, findMountElement } from './main.js';
import Inliner from '@thehotelsnetwork/personalization-inliner/dist/inliner.es';
import css from '@thehotelsnetwork/personalization-inliner/dist/inliner.styles';
import { createRootContainer, insertRootContainer } from './chunk-insert-root-container.js';
import { createPcomponentParam } from './chunk-create-pcomponent-param.js';
import './chunk-widgets.js';
import '@thehotelsnetwork/md5';

const factory = ({ document, thn, }) => {
    const viewData = {};
    const widgetView = {
        data: viewData,
        async show({ bundle }) {
            const debugPrefix = 'show()';
            const { tool } = bundle;
            const fontsData = tool.getFontsData();
            if (fontsData) {
                const fontsLoader = await this.container.async.fontsLoader;
                const fontsPromise = AbortablePromise.from(fontsLoader.addFonts(fontsData, document));
                thn.pageUnload(() => fontsPromise.abort());
                try {
                    await fontsPromise;
                }
                catch (error) {
                    if (error instanceof AbortError) {
                        return;
                    }
                    throw error;
                }
            }
            const id = `${this.data.name}-${tool.getId()}`;
            const mountSelector = tool.getMountSelector();
            const options = { checkId: id, document };
            // First try: search the position in this document
            // TODO: Esto deberia tener el tipo correcto. Vscode no lo ve
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
            const reference = findMountElement(mountSelector, options);
            if (!reference) {
                const selector = mountSelector || 'no selector';
                const error = new Error(`Unable to find the target container "${selector}"`);
                error.status = 'no-selector';
                throw error;
            }
            // DOM Element style
            const styleProps = {
                'background-color': 'transparent',
                border: 0,
                display: 'block',
                float: 'none',
                margin: 0,
                padding: 0,
                position: 'relative',
                'z-index': 0,
            };
            const { shadowEl, topElement } = createRootContainer({
                id,
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                contentStyles: css,
                topElementStyles: styleProps,
            });
            const position = tool.getPosition() || '';
            const isRootInserted = insertRootContainer(reference, topElement, position);
            if (!isRootInserted) {
                this.logger.warn(debugPrefix, 'Failed to inject root container in the DOM with data:', { reference, element: topElement, position: bundle.devicePosition });
                const error = new Error('Unable to insert the root container in the DOM');
                error.status = 'no-selector';
                throw error;
            }
            // Create the vue app
            await this.container.scheduler.yield();
            const app = createApp(Inliner, createPcomponentParam(bundle));
            app.mount(shadowEl);
            // hide on page unloading
            this.onDestroy(() => {
                app.unmount();
                topElement.remove();
            });
        },
    };
    return widgetView;
};

export { factory };
